import React from "react";
import {
  PublishModal,
  SubmitReviewModal,
} from "@js/invenio_rdm_records";
import { parametrize } from "react-overridable";

// -----------------------------------------------------------------------------
// Zusatz-Checkboxen
// -----------------------------------------------------------------------------
const extraCheckboxes = [
  {
    id: "acceptCommunityPolicy",
    fieldPath: "acceptCommunityPolicy",
    text: <>I submit this dataset in compliance with the communities policy.</>,
  },
  {
    id: "acceptFDATAgreement",
    fieldPath: "acceptFDATAgreement",
    text: (
      <>
        I confirm that this dataset complies with the FDAT{" "}
        <a href="/data_agreement" target="_blank" rel="noopener noreferrer">
          Submission and Reuse Agreement.
        </a>
      </>
    ),
  },
];

// -----------------------------------------------------------------------------
// Before-Inhalt
// -----------------------------------------------------------------------------
const BeforeContent = () => (
  <p>Please review the following before continuing:</p>
);

// -----------------------------------------------------------------------------
// Modals
// -----------------------------------------------------------------------------
const PublishModalComponent = parametrize(PublishModal, {
  extraCheckboxes,
  beforeContent: BeforeContent,
});

const SubmitReviewModalComponent = parametrize(SubmitReviewModal, {
  extraCheckboxes,
  beforeContent: BeforeContent,
});

// -----------------------------------------------------------------------------
// Registrierung
// -----------------------------------------------------------------------------
export const overriddenComponents = {
  "InvenioRdmRecords.PublishModal.container": PublishModalComponent,
  "InvenioRdmRecords.SubmitReviewModal.container": SubmitReviewModalComponent,
};
